import { React, useState, useRef, useEffect, Fragment } from "react";
import {
  useToast, Text, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper,
  Menu, MenuButton, MenuList, MenuItem, MenuDivider, Icon, Avatar, AvatarBadge, Modal,
  ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Box, Button, useDisclosure, Stack, FormControl, FormLabel, Select, Input,
  CloseButton, Switch,
  InputRightElement, InputGroup,
  Tooltip, HStack,
} from '@chakra-ui/react';
import { Progress } from '@chakra-ui/react';
import { MdAddBox, MdLockReset, MdOutlineDashboard, MdOutlineDataset, MdOutlineHome, MdOutlinePerson, MdOutlineReceipt, MdOutlineTableChart, MdStopCircle, MdVisibility, MdVisibilityOff } from 'react-icons/md'
import { MdOutlineMenuBook, MdOutlineAnalytics, MdDelete, MdCheckCircle } from "react-icons/md";
import { MdFileOpen } from "react-icons/md";

import { FaExternalLinkAlt, FaDownload } from "react-icons/fa";
import { PiListPlusFill } from "react-icons/pi";
import { RiContactsBookUploadLine } from "react-icons/ri";
import { BsFillInfoCircleFill, BsFillClipboardDataFill } from "react-icons/bs";
import { SearchIcon } from "@chakra-ui/icons";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from '../SessionContext';
import { IoMdPower, IoMdStats } from "react-icons/io";
import { SiJupyter } from "react-icons/si";
import { CgSearchLoading } from "react-icons/cg";
import { HiMiniAdjustmentsHorizontal } from "react-icons/hi2"
import { GiZeppelin, GiGearHammer } from "react-icons/gi";
import { PiSupersetOf } from "react-icons/pi";
import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";
import createAxiosInstance from "../interceptors/useAxiosInterceptors"
import logout from "../services/authService";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { RiSurveyLine } from "react-icons/ri";
import { GrUserExpert } from "react-icons/gr";
import { MdGroups } from "react-icons/md";
import { ImExit } from "react-icons/im";
import { useTranslation } from "react-i18next";
import { hasAccents } from "../services/utils";
import SpinnerXL from "./SpinnerXL";
import { FaFileContract } from "react-icons/fa";
import { FaLink } from "react-icons/fa6";
import { useMemo } from 'react';
import { TbWorld } from "react-icons/tb";
import { FaRobot } from "react-icons/fa6";
// import { useDigitalAssistant } from "../context/DigitalAssistantContext";

function Navbar() {

  // const { openAssistant } = useDigitalAssistant();

  //INIZIO API GEOPORTAL

  const [isIframeOpen, setIsIframeOpen] = useState(false);
  const [htmlPage, setHtmlPage] = useState(``);
  const [internalServiceURL, setInternarlServiceURL] = useState(``);

  // const fetchInternalService = async (item) => {
  //   try {
  //     // Check if item and item.service_url exist
  //     if (!item || !item.service_url) {
  //       toast({
  //         title: t('toastMsg.error'),
  //         description: t('toastMsg.missingServiceUrl'),
  //         position: "top",
  //         status: 'error',
  //         duration: 4000,
  //         isClosable: true,
  //       });
  //       return;
  //     }

  //     const requestData = {
  //       BearerToken: sessionStorage.getItem("token"),
  //       username: sessionStorage.getItem("username"),
  //       urlService: item.service_url // Use the URL from the specific service
  //     };
  //     const options = {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //     };

  //     const urlFetch = `${react_api}/services/getInternalServiceADP`;
  //     const response = await axiosInstance.post(urlFetch, requestData, options);

  //     const result = response.data;

  //     if (response.status.toString() === HTTP_STATUS_CODES.OK) {
  //       setHtmlPage(result);
  //       setIsIframeOpen(true);
  //     } else {
  //       toast({
  //         title: t('toastMsg.error'),
  //         description: result.message ? t(`messageBE.${result.message}`) : t('toastMsg.genericError'),
  //         position: "top",
  //         status: 'error',
  //         duration: 4000,
  //         isClosable: true,
  //       });
  //     }
  //   } catch (error) {
  //     toast({
  //       title: t('toastMsg.callError'),
  //       description: String(error),
  //       position: "top",
  //       status: 'warning',
  //       duration: 4000,
  //       isClosable: true,
  //     });
  //   }
  // };
  //FINE API GEOPORTAL


  const { t } = useTranslation();
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const toast = useToast();
  const fileFormats = [{ label: "", value: [""] }, { label: "csv", value: [".csv"] }, { label: "xlsx", value: [".xlsx", ".xls"] }, { label: "shapefile", value: [".zip", ".rar"] }
    , { label: "json", value: [".json"] },
  { label: "GeoJSON", value: [".geojson"] },
  { label: "GeoPackage", value: [".gpkg"] }
  ];
  const fileSelectorRef = useRef(null);
  let defaultPayloadUploadRequestValue = { version: "1.0", titolo: null, file: null, fileFormat: "", is_update: false, updateDate: "" }
  const [payloadUploadRequest, setPayloadUploadRequest] = useState(defaultPayloadUploadRequestValue);
  const [selectedFileFormat, setSelectedFileFormat] = useState(fileFormats[0].value);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [maxFileSize, setMaxFileSize] = useState(Infinity);
  const [selectedMessage, setSelectedMessage] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [isUploadUrl, setIsUploadUrl] = useState(null)
  const [isUpdate, setIsUpdate] = useState(false);
  const fileUrlFormats = [
    { label: "", value: [""] },
    { label: "csv", value: [".csv"] },
    { label: "xlsx", value: [".xlsx", ".xls"] }
  ];
  const fileFormatsOptions = useMemo(() => {
    return isUploadUrl ? fileUrlFormats : fileFormats;
  }, [isUploadUrl]);

  useEffect(() => {
    // const role = sessionStorage.getItem("role");
    // if (role) {
    //   userRole(role);
    // }
    const role = sessionStorage.getItem("role") ?? "";
    userRole(role);

    // fetchInternalService();
  }, []); // Array di dipendenze vuoto per eseguire solo una volta

  const [responseChangePassword, setResponseChangePassword] = useState({});

  const playMex = () => {
    if (payloadUploadRequest.fileFormat === "csv") {
      toast({
        title: t('toastMsg.callError'),

        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }

  }

  // Configurazione Attivazione/Disattivazione Funzioni del Menu 
  const [state, setState] = useState({
    isHomeMI: false,
    isDatasetMI: false,
    isStagingAreaMI: false,
    isMyResultsMI: false,
    isProcessingMI: false,
    isDashboardMI: false,
    isLcaCatalogMI: false,
    isQueryMI: false,
    isJupyterMI: false,
    isZeppelinMI: false,
    isSupersetMI: false,
    isUploadMI: false,
    isChangePasswordMI: false,
    isInfoMI: false,
    isDigitalAssistantMI: false,
    isQueryToolsMB: false,
    isDevToolsMB: false,
    isCatalogMB: false,
    isProfileButtonMB: false,
    isServicesMB: false,
    isSurveyMB: false,
    isGeoportalMB: false,
    isRoleManagerMB: false
  });

  const userRole = (ruolo) => {

    switch (ruolo) {

      case "Researcher":

        setState((prevState) => ({
          ...prevState,
          isSurveyMB: false,
          isDigitalAssistantMI: true,
          isLcaCatalogMI: false,
          isRoleManagerMB: false
        }));

        break;

      case "Publisher":

        setState((prevState) => ({
          ...prevState,
          isMyResultsMI: true,
          isProcessingMI: true,
          isZeppelinMI: true,
          isJupyterMI: true,
          isSupersetMI: true,
          isQueryToolsMB: true,
          isGeoportalMB: true,
          isLcaCatalogMI: false,
          isRoleManagerMB: false
        }));

        break;

      case "UserWeb":

        setState((prevState) => ({

          ...prevState,
          isStagingAreaMI: true,
          isMyResultsMI: true,
          isProcessingMI: true,
          isDevToolsMB: true,
          isRoleManagerMB: false
        }));

        break;

      case "LCAManager":
        setState((prevState) => ({

          ...prevState,
          isDatasetMI: true,
          isStagingAreaMI: true,
          isMyResultsMI: true,
          isProcessingMI: true,
          isDashboardMI: true,
          isLcaCatalogMI: false,
          isJupyterMI: true,
          isZeppelinMI: true,
          isSupersetMI: true,
          isInfoMI: false,
          isUploadMI: true,
          isQueryMI: true,
          isChangePasswordMI: false,
          isDigitalAssistantMI: false,
          isQueryToolsMB: true,
          isDevToolsMB: true,
          isCatalogMB: false,
          isServicesMB: true,
          isProfileButtonMB: false,
          isSurveyMB: true,
          isGeoportalMB: true, //Controllare Inizializzazione STATO
          isRoleManagerMB: false
        }));

        break;

      default:

        setState({
          isHomeMI: true,
          isDatasetMI: true,
          isStagingAreaMI: true,
          isMyResultsMI: true,
          isProcessingMI: true,
          isDashboardMI: true,
          isLcaCatalogMI: true,
          isQueryMI: true,
          isJupyterMI: true,
          isZeppelinMI: true,
          isSupersetMI: true,
          isUploadMI: true,
          isChangePasswordMI: true,
          isInfoMI: true,
          isDigitalAssistantMI: true,
          isQueryToolsMB: true,
          isDevToolsMB: true,
          isCatalogMB: true,
          isProfileButtonMB: false,
          isServicesMB: true,
          isSurveyMB: true,
          isGeoportalMB: true,
          isRoleManagerMB: true
        });

        break;

    }

  };

  // console.log(state);

  const handleChangePayloadRequest = (event, key) => {

    switch (key) {


      case "version":
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: event
        }));
        break

      case "titolo":
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: event.target.value
        }));
        break
      case "fileFormat":
        switch (event.target.selectedOptions[0].label) {
          case "csv":
            toast({
              title: t('toastMsg.navbar.info'),
              description: t('toastMsg.navbar.csvDelimiters'),
              status: 'info',
              duration: 4000,
              isClosable: true
            })
            break
          case 'shapefile':
            toast({
              title: t('toastMsg.navbar.info'),
              description: t('toastMsg.navbar.shapefileFormat'),
              status: 'info',
              duration: 4000,
              isClosable: true
            })
        }

        setSelectedFileFormat(event.target.value.split(","))
        let label = event.target.selectedOptions[0].label
        if (label == "GeoJSON")
          label = "geojson"

        if (label == "GeoPackage")
          label = "gpkg"
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: label
        }));

        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          file: null
        }));

        if (!isUploadUrl) {
          fileSelectorRef.current.value = ""
        }

        break

      case "file":

        let file = event.target.files[0]




        if (file) {
          const isValidExtension = selectedFileFormat.some(ext => file.name.endsWith(ext));
          if (!isValidExtension) {
            event.target.value = '';
            setPayloadUploadRequest(payloadUploadRequest => ({
              ...payloadUploadRequest,
              file: null
            }));
            return
          }
        }

        let maxSize = 500 * 1024 * 1024;
        // let maxSize = Infinity;
        // if (payloadUploadRequest.fileFormat === "csv") {
        //   maxSize = 750 * 1024 * 1024;
        // } 
        // else if (payloadUploadRequest.fileFormat === "shapefile") {
        //   maxSize = 250 * 1024 * 1024;
        // } 
        setMaxFileSize(maxSize);
        if (file.size > maxSize) {
          event.target.value = '';
          setPayloadUploadRequest(prev => ({ ...prev, file: null }));
          toast({
            title: t('toastMsg.error'),
            description: t('toastMsg.uploadDatasetModal.fileExceedsMaximumSize') + ' (MAX : ' + (maxSize / (1024 * 1024)) + ' MB)',
            status: 'error',
            duration: 4000,
            isClosable: true
          });
          return;
        }

        if (hasAccents(file.name)) {

          event.target.value = '';
          setPayloadUploadRequest(payloadUploadRequest => ({
            ...payloadUploadRequest,
            file: null
          }));

          toast({
            title: t('toastMsg.error'),
            description: t('toastMsg.navbar.fileNameCannotContainAccents'),
            status: 'warning',
            duration: 4000,
            isClosable: true
          })
          return
        }

        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: file
        }));

        break

      case "is_update":
        const { checked } = event.target;
        setIsUpdate(checked);
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: checked
        }));

        break

      case "updateDate":
        setPayloadUploadRequest(payloadUploadRequest => ({
          ...payloadUploadRequest,
          [key]: event.target.value
        }));
        break;

      default:
        break
    }

  };

  const isValidUrlFormat = (url) => {
    try {
      new URL(url);
      return url.startsWith('http://') || url.startsWith('https://');
    } catch (error) {
      return false;
    }
  };
  const validateUrl = async () => {
    const url = currentUrl.trim();
    if (!url) {
      toast({
        title: t('toastMsg.uploadDatasetModal.urlIsMandatory'),
        position: 'top',
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      return;
    }
    if (!isValidUrlFormat(url)) {
      toast({
        title: t('toastMsg.uploadDatasetModal.invalidFormatUrl'),
        position: 'top',
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      return;
    }
    setIsValidating(true);

    try {

      const response = await fetch(url, { method: 'HEAD', mode: 'no-cors' })
        .then(() => ({ success: true }))
        .catch(() => ({ success: false }));

      if (response.success) {
        try {
          const urlObj = new URL(url);
          const pathname = urlObj.pathname;
          const ext = pathname.substring(pathname.lastIndexOf('.')).toLowerCase();

          const selectedFormat = payloadUploadRequest.fileFormat;
          const allowedFormat = fileFormats.find(f => f.label.toLowerCase() === selectedFormat.toLowerCase());

          if (allowedFormat && !allowedFormat.value.includes(ext)) {
            toast({
              title: t('toastMsg.error'),
              description: t('toastMsg.uploadDatasetModal.fileMustBeInFormat') + " " + selectedFormat.toUpperCase() + " (" + t('toastMsg.uploadDatasetModal.extension') + " : " + allowedFormat.value.join(" / ") + ") ",
              position: 'top',
              status: 'error',
              duration: 4000,
              isClosable: true
            });
            setIsValidating(false);
            return;
          }
        } catch (err) {
          toast({
            title: t('toastMsg.error'),
            description: t('toastMsg.uploadDatasetModal.errorDuringValidation'),
            position: 'top',
            status: 'error',
            duration: 4000,
            isClosable: true
          });
          setIsValidating(false);
          return;
        }
        setPayloadUploadRequest(prev => ({
          ...prev,
          urlDownloadFile: url
        }));
        setCurrentUrl("");
        toast({
          title: t('toastMsg.uploadDatasetModal.urlSuccessfullyValidated'),
          status: 'success',
          position: "top",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: t('toastMsg.error'),
          description: t('toastMsg.uploadDatasetModal.urlIsInvalid'),
          position: 'top',
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }
    } catch (error) {
      toast({
        title: t('toastMsg.error'),
        description: t('toastMsg.uploadDatasetModal.errorDuringValidation'),
        position: 'top',
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    } finally {
      setIsValidating(false);
    }
  };
  const removeUrl = () => {
    setPayloadUploadRequest(prev => ({
      ...prev,
      urlDownloadFile: ""
    }));
    toast({
      title: t('toastMsg.uploadDatasetModal.urlRemoved'),
      status: 'info',
      position: "top",
      duration: 2000,
      isClosable: true,
    });
  };

  const uploadDataset = async () => {
    if (payloadUploadRequest.file && payloadUploadRequest.file.size > maxFileSize) {
      toast({
        title: t('toastMsg.error'),
        description: t('toastMsg.uploadDatasetModal.fileExceedsMaximumSize') + '(MAX : ' + (maxFileSize / (1024 * 1024)) + ' MB)',
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      return;
    }
    if (payloadUploadRequest.is_update) {
      if (
        payloadUploadRequest.updateDate == null || payloadUploadRequest.updateDate.length === 0 ||
        (!isUploadUrl && payloadUploadRequest.file == null) ||
        (isUploadUrl && payloadUploadRequest.urlDownloadFile == null) ||
        payloadUploadRequest.fileFormat == null
      ) {
        toast({
          title: t('toastMsg.error'),
          description: isUploadUrl ? t('toastMsg.uploadDatasetModal.updateFileUrl') : t('toastMsg.uploadDatasetModal.updateFile'),
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }
    } else {
      if (
        payloadUploadRequest.titolo == null || payloadUploadRequest.titolo.length === 0 ||
        (!isUploadUrl && payloadUploadRequest.file == null) ||
        (isUploadUrl && payloadUploadRequest.urlDownloadFile == null) ||
        (payloadUploadRequest.fileFormat == null || payloadUploadRequest.fileFormat === "")
      ) {
        toast({
          title: t('toastMsg.error'),
          description: isUploadUrl ? t('toastMsg.uploadDatasetModal.newFileUrl') : t('toastMsg.uploadDatasetModal.newFile'),
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
        return;
      }
    }

    try {
      setIsUploading(true);
      setUploadProgress(0);

      const fileSize = payloadUploadRequest.file ? payloadUploadRequest.file.size : 0;
      const fileSizeMB = fileSize / (1024 * 1024);
      const factor = 0.2;
      const simulatedDurationSec = Math.max(fileSizeMB * factor, 5);
      const incrementPerSec = simulatedDurationSec > 0 ? 97 / simulatedDurationSec : 97;

      const progressTimer = setInterval(() => {
        setUploadProgress(prev => {
          const next = prev + incrementPerSec;
          if (next >= 97) {
            clearInterval(progressTimer);
            return 97;
          }
          return next;
        });
      }, 1000);


      const formData = new FormData();
      formData.append("username", sessionStorage.getItem("username"));

      Object.keys(payloadUploadRequest).forEach(payloadUploadRequestKey => {
        formData.append(payloadUploadRequestKey, payloadUploadRequest[payloadUploadRequestKey]);
      });

      const options = {
        headers: {
          'Authorization': sessionStorage.getItem("token"),
          'Content-Type': 'multipart/form-data',
        },
      };
      // const urlFetch = isUploadUrl ? `${react_api}/privateServices/uploadDataADPUrl` : `${react_api}/privateServices/uploadDataADP`;
      const urlFetch = `${react_api}/privateServices/uploadDataADP`;
      const response = await axiosInstance.post(urlFetch, formData, options);
      const result = response.data;

      if (result.status === HTTP_STATUS_CODES.OK) {
        setUploadProgress(100);
        toast({
          title: t(`messageBE.${result.message}`),
          description: "",
          status: 'info',
          duration: 4000,
          isClosable: true
        });
        onUploadModalClose();
        setSelectedFileFormat(fileFormats[0].value)
        setPayloadUploadRequest(defaultPayloadUploadRequestValue);
      } else if (result.status !== HTTP_STATUS_CODES.OK) {
        toast({
          title: t(`messageBE.${result.message}`),
          description: "",
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      } else {
        throw new Error(t('navbar.throwNewError.dataRecoveryError'));
      }

    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });

  const { updateSessionData, clearSessionData } = useSession();
  const navigate = useNavigate();

  function deleteAllCookies() {
    // Ottiene tutti i cookie
    const cookies = document.cookie.split(";");

    // Scorre ogni cookie
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      // Trova il nome del cookie
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      // Imposta ogni cookie con una data di scadenza passata
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }

  const logOutJupyterHubTwo = async () => {
    try {
      const urlFetch = `https://131.175.205.207:55548/hub/logout`;

      const response = await axiosInstance.get(urlFetch);

      if (response.status === 200) {
        toast({
          title: t('toastMsg.navbar.logoutJupyter2Success'),
          description: String(response.data.message),
          position: "top",
          status: 'info',
          duration: 4000,
          isClosable: true
        });
      }
    } catch (error) {
      toast({
        title: t('toastMsg.navbar.logoutJupyter2Error'),
        description: String(error.message),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };

  const logOut = async () => {
    let toastId = 1

    if (toast.isActive(toastId)) {
      toast.close(toastId);
    }
    try {
      setSpinnerLoading(true);
      const richiesta = {
        BearerToken: sessionStorage.getItem("token"),

      }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(richiesta),
      }

      const urlFetch = `${react_api}/logoutADP`;
      const response = await fetch(urlFetch, options);
      const result = await response.json();
      if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.error'),
          description: t(`messageBE.${result.message}`),
          position: "top",
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }
      if (result.status == HTTP_STATUS_CODES.OK) {
        setSpinnerLoading(false);
        if (!toast.isActive(toastId)) {

          toast({
            id: toastId,
            title: t('toastMsg.navbar.logoutSuccess'),
            description: String(result.message),
            position: "top",
            status: 'info',
            duration: 1700,
            isClosable: true, onCloseComplete: () => {

              clearSessionData();
              navigate('/home');
              window.location.reload();
            }
          });

        }

      }
    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };
  const changePasswordADP = async () => {
    try {


      setSpinnerLoading(true);
      if (newPassword1.length < 8 || newPassword1.length > 15) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.navbar.passwordError'),
          description: t('toastMsg.navbar.passwordErrorLenght'),
          position: "top",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      if (/[@'"]/.test(newPassword1)) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.navbar.passwordError'),
          description: t('toastMsg.navbar.passwordErrorSpecialCharacter'),
          position: "top",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      if (!/\d/.test(newPassword1)) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.navbar.passwordError'),
          description: t('toastMsg.navbar.passwordErrorNotContainOneNumber'),
          position: "top",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      if (!/[A-Z]/.test(newPassword1)) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.navbar.passwordError'),
          description: t('toastMsg.navbar.passwordErrorNotContainOneCapitalLetter'),
          position: "top",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      if (!/[!#$%&()*+,\-./:;<=>?[\]^_`{|}~]/.test(newPassword1)) {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.navbar.passwordError'),
          description: t('toastMsg.navbar.passwordErrorNotContainOneSpecialCharacter'),
          position: "top",
          status: "warning",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      if (newPassword1 == newPassword2) {
        console.info("prima password inserita: ", newPassword1)
        console.info("seconda password inserita: ", newPassword2)

        const urlFetch = `${react_api}/changePasswordADP`;
        const richiesta = {
          BearerToken: sessionStorage.getItem('token'),
          newPass: newPassword1
        }
        const options = {

          headers: {
            'Content-Type': 'application/json'
          },

        }




        const response = await axiosInstance.post(urlFetch, richiesta, options);

        if (response.data.status === HTTP_STATUS_CODES.OK) {
          setSpinnerLoading(false);
          setResponseChangePassword(response.data)


          onChangePasswordModalClose()
          onChangeLogoutPasswordModalOpen()

          toast({
            title: t(`messageBE.${response.data.message}`),
            position: "top",
            status: 'success',
            duration: 6000,
            isClosable: true
          });
        }
      } else {
        setSpinnerLoading(false);
        toast({
          title: t('toastMsg.navbar.passwordMismatch'),

          position: "top",
          status: 'warning',
          duration: 6000,
          isClosable: true
        });
      }
    } catch (error) {
      setSpinnerLoading(false);
      toast({
        title: t('toastMsg.navbar.passwordChangeError'),
        description: String(error.message),
        position: "top",
        status: 'warning',
        duration: 6000,
        isClosable: true
      });
    }

  }
  const handleChangePassword1 = (ev) => {
    setNewPassword1(ev.target.value.trim())
    console.info(newPassword1)
  }

  const [newPassword1, setNewPassword1] = useState();

  const handleChangePassword2 = (ev) => {
    setNewPassword2(ev.target.value.trim())
    console.info(newPassword2)
  }

  const [newPassword2, setNewPassword2] = useState();

  const [showPassword1, setShowPassword1] = useState(false);

  const handlePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };
  const [showPassword2, setShowPassword2] = useState(false);

  const handlePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };
  const { isOpen: isLogoutModalOpen, onOpen: onLogoutModalOpen, onClose: onLogoutModalClose } = useDisclosure();
  const { isOpen: isUploadModalOpen, onOpen: onUploadModalOpen, onClose: onUploadModalClose } = useDisclosure();
  const { isOpen: isChangePasswordModalOpen, onOpen: onChangePasswordModalOpen, onClose: onChangePasswordModalClose } = useDisclosure();

  const { isOpen: isLogoutChangePasswordModalOpen, onOpen: onChangeLogoutPasswordModalOpen, onClose: onChangeLogoutPasswordModalClose } = useDisclosure();

  //const { isOpen, onOpen, onClose } = useDisclosure()

  const { sessionData } = useSession();

  // const sessionUserRole = contextSessionData?.role || 'UserWeb';
  // console.log(sessionData.role);

  const generateAvatar = (username) => {
    const array = username.split(" ");
    const name = array[0]
    const surname = array[1] || ''
    const initials = `${name.charAt(0)} + ${surname.charAt(0)}`;

    return (
      <Avatar name={initials} size="md" bg={"#006778"} color={"yellowgreen"} paddingBottom={"2%"} paddingTop={"2%"} ><AvatarBadge bgColor={"green"} borderWidth={1} boxSize={"0.8em"} /></Avatar>
    );
  };

  return (
    <Menu minH="100%" minW="100%" >
      {spinnerLoading && (
        <SpinnerXL />
      )}
      {/*<MenuItem bgColor={"rgba(11,78,90,255)"} paddingRight={0} paddingLeft={0} paddingTop={0} paddingBottom={0}>
              <Image src={LogoGrinsProva} alt='Logo Grins Foundation' height={"100%"} width={"100%"} />
              </MenuItem>*/}
      {!state.isHomeMI &&(
        <Link to="/home">
          <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
            <MenuButton color={"yellowgreen"} w="100%" h="100%" paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
              transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }} >
              <Icon as={MdOutlineHome} w={"30%"} h={"30%"} />
              <Text fontSize={"sm"}> Home </Text></MenuButton>
          </MenuItem>
        </Link>
      )}
      {/* CATALOG */}
      {!state.isCatalogMB && (
      <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
        <Menu>
          <Tooltip label={state.isCatalogMB ? null : t('toolTip.tooltipNavbar.catalog')} placement="right">
            <MenuButton disabled={state.isCatalogMB} color={!state.isCatalogMB ? "yellowgreen" : "gray.400"} cursor={!state.isCatalogMB ? "pointer" : "not-allowed"} w="100%" h="100%" paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
              transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }}
              _focus={{ boxShadow: 'outline' }}>
              <Icon as={MdOutlineTableChart} w={"30%"} h={"30%"} />
              <Text fontSize={"sm"}> {t('navbar.catalog')} </Text>
            </MenuButton>
          </Tooltip>
          <MenuList border="solid" borderColor="rgba(11,78,90,255)" borderWidth="1" marginLeft="40%">
            {!state.isDatasetMI && (
              <Link to={"/dataset"}>
                <Tooltip label={t('toolTip.tooltipNavbar.catalogMenu.datasets')} placement="right">
                  <MenuItem isDisabled={state.isDatasetMI} _hover={{ bg: "gray.300" }}>
                    <Icon as={MdOutlineDataset} mr={1} /> Datasets
                  </MenuItem>
                </Tooltip>
              </Link>
            )}

            {!state.isStagingAreaMI && (
              <Fragment>
                <Link to={"/stagingarea"}>
                  <Tooltip label={t('toolTip.tooltipNavbar.catalogMenu.stagingArea')} placement="right">
                    <MenuItem isDisabled={state.isStagingAreaMI} _hover={{ bg: "gray.300" }}>
                      <Icon as={MdStopCircle} mr={1} /> {t('navbar.stagingArea')}
                    </MenuItem>
                  </Tooltip>
                </Link>
                <MenuDivider />
              </Fragment>
            )}

            {!state.isMyResultsMI && (
              <Link to={"/risultati"}>
                <Tooltip label={t('toolTip.tooltipNavbar.catalogMenu.myResults')} placement="right">
                  <MenuItem isDisabled={state.isMyResultsMI} _hover={{ bg: "gray.300" }}>
                    <Icon as={MdOutlineReceipt} mr={1} /> {t('navbar.myResults')}
                  </MenuItem>
                </Tooltip>
              </Link>
            )}

            {!state.isProcessingMI && (
              <Fragment>
                <Link to={"/processing"}>
                  <Tooltip label={t('toolTip.tooltipNavbar.catalogMenu.processing')} placement="right">
                    <MenuItem isDisabled={state.isProcessingMI} _hover={{ bg: "gray.300" }}>
                      <Icon as={HiMiniAdjustmentsHorizontal} mr={1} /> {t('navbar.processing')}
                    </MenuItem>
                  </Tooltip>
                </Link>
                <MenuDivider />
              </Fragment>
            )}

            {!state.isDashboardMI && (
              <Fragment>
                <Link to={"/dashboard"}>
                  <Tooltip label={t('toolTip.tooltipNavbar.catalogMenu.dashboard')} placement="right">
                    <MenuItem isDisabled={state.isDashboardMI} _hover={{ bg: "gray.300" }}>
                      <Icon as={MdOutlineDashboard} mr={1} /> Dashboard
                    </MenuItem>
                  </Tooltip>
                </Link>
                <MenuDivider />
              </Fragment>
            )}

            <Link to={"/lca-catalog"}>
              <Tooltip label="Life Cycle Assessment (LCA)" placement="right">
                <MenuItem isDisabled={state.isLcaCatalogMI} _hover={{ bg: "gray.300" }}>
                  {/* <MenuItem isDisabled={true} _hover={{ bg: "gray.300" }}> */}
                  <Icon as={MdFileOpen} mr={1} /> LCA
                </MenuItem>
              </Tooltip>
            </Link>
          </MenuList>

        </Menu>
      </MenuItem>
      )}
      {/* INIZIO SERVICES */}
      {!state.isServicesMB && (
        <Menu>
          <Link to="/my-services">
            <Tooltip label={t('toolTip.tooltipNavbar.services')} placement="right">
              <MenuItem
                _focus={{ bg: "#006778" }}
                paddingRight={0}
                paddingLeft={0}
                paddingTop={0}
                paddingBottom={0}
                mb={2}
              >
                <MenuButton
                  color="yellowgreen"
                  cursor="pointer"
                  w="100%"
                  h="100%"
                  paddingRight="2%"
                  paddingLeft="2%"
                  paddingTop="2%"
                  paddingBottom="2%"
                  transition="all 0.2s"
                  borderRadius="md"
                  _hover={{ boxShadow: "dark-lg" }}
                  _expanded={{ bg: "blue.400" }}
                  _focus={{ boxShadow: "outline" }}
                >
                  <Icon as={MdOutlineMiscellaneousServices} w="30%" h="30%" />
                  <Text fontSize="sm">{t('navbar.services')}</Text>
                </MenuButton>
              </MenuItem>
            </Tooltip>
          </Link>
        </Menu>
      )}
      {/* <Menu>
        <Link to="/my-services">
          <Tooltip label={state.isServicesMB ? null : t('toolTip.tooltipNavbar.services')} placement="right">
            <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
              <MenuButton disabled={state.isServicesMB} color={!state.isServicesMB ? "yellowgreen" : "gray.400"} cursor={!state.isServicesMB ? "pointer" : "not-allowed"} w="100%" h="100%" paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
                transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }}
                _focus={{ boxShadow: 'outline' }}>
                <Icon as={MdOutlineMiscellaneousServices} w={"30%"} h={"30%"} />
                <Text fontSize={"sm"}>{t('navbar.services')}</Text>
              </MenuButton>
            </MenuItem>
          </Tooltip>
        </Link>
      </Menu> */}
      {/* <MenuList border="solid" borderColor={"rgba(11,78,90,255)"} borderWidth={"1"} marginLeft={"40%"} >
            <Link to={"/service-intro"}>
              <MenuItem _hover={{ bg: "gray.300" }}>
                <Icon as={MdOutlineMiscellaneousServices} />Service 1
              </MenuItem>
            </Link>
            <MenuItem _hover={{ bg: "gray.300" }}>
              <Icon as={MdOutlineMiscellaneousServices} />Service 2
            </MenuItem>
            <MenuItem _hover={{ bg: "gray.300" }}>
              <Icon as={MdOutlineMiscellaneousServices} />Service 3
            </MenuItem>
            <MenuItem _hover={{ bg: "gray.300" }}>
              <Icon as={MdOutlineMiscellaneousServices} />Service 4
            </MenuItem>
            <MenuItem _hover={{ bg: "gray.300" }}>
              <Icon as={MdOutlineMiscellaneousServices} />Service 5
            </MenuItem>
          </MenuList> */}
      {/* FINE SERVICES */}
      <Link to="/sviluppo">

      </Link>

      <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
        <Menu>
          {!state.isQueryToolsMB && (
            <Tooltip label={state.isQueryToolsMB ? null : t('toolTip.tooltipNavbar.query&analysis')} placement="right">
              <MenuButton disabled={state.isQueryToolsMB} color={!state.isQueryToolsMB ? "yellowgreen" : "gray.400"} cursor={!state.isQueryToolsMB ? "pointer" : "not-allowed"}
                w="100%" h="100%" transition='all 0.2s' paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
                borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }}
                _focus={{ boxShadow: 'outline' }}><Icon as={CgSearchLoading} w={"30%"} h={"30%"} />
                <Text fontSize={"sm"}> Query & Analysis</Text>
              </MenuButton>
            </Tooltip>
          )}
          <MenuList border="solid" borderColor={"rgba(11,78,90,255)"} borderWidth={"1"} marginLeft={"40%"}>
            <Link to="/query" >
              <Tooltip label={t('toolTip.tooltipNavbar.query&analysisMenu.queryTools')} placement="right" >
                <MenuItem isDisabled={state.isQueryMI} _hover={{ bg: "gray.300" }}>
                  <Icon as={SearchIcon} mr={2} />
                  <Text> Query tool</Text>
                </MenuItem>
              </Tooltip>
            </Link>
            <Link to="/data-analysis" >
              <Tooltip label={t('toolTip.tooltipNavbar.query&analysisMenu.dataAnalysis')} placement="right" >
                <MenuItem isDisabled={state.isQueryMI} _hover={{ bg: "gray.300" }}>
                  <MdOutlineAnalytics size={25} />
                  <Text ml={1}> Data Analysis</Text>
                </MenuItem>
              </Tooltip>
            </Link>
            {/* <MenuDivider />
            <Link to="/safeai" >
              <Tooltip label={t('toolTip.tooltipNavbar.query&analysisMenu.safeai')} placement="right" >
                <MenuItem _hover={{ bg: "gray.300" }}>
                  <BsFillClipboardDataFill size={25} />
                  <Text ml={1}> S.A.F.E.</Text>
                </MenuItem>
              </Tooltip>
            </Link> */}
            {/* <MenuDivider />
            <Link to="/Geoportal" >
              <MenuItem isDisabled={false} _hover={{ bg: "gray.300" }}>
                <TbWorld size={25} />
                <Text ml={1}> Geoportal</Text>
              </MenuItem>
            </Link> */}
          </MenuList>
        </Menu>
      </MenuItem>
      {/* vechia posiz. SERVICES */}

      {/* DEVELOPMENT TOOLS */}
      {!state.isDevToolsMB && (
        <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
          <Menu>
            <Tooltip label={state.isDevToolsMB ? null : t('toolTip.tooltipNavbar.devTools')} placement="right">
              <MenuButton disabled={state.isDevToolsMB} color={!state.isDevToolsMB ? "yellowgreen" : "gray.400"} cursor={!state.isDevToolsMB ? "pointer" : "not-allowed"} w="100%" h="100%" transition='all 0.2s' paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
                borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }}
                _focus={{ boxShadow: 'outline' }}><Icon as={GiGearHammer} w={"30%"} h={"30%"} />
                <Text fontSize={"sm"}> {t('navbar.developmentTools')} </Text>
              </MenuButton>
            </Tooltip>
            <MenuList border="solid" borderColor={"rgba(11,78,90,255)"} borderWidth={"1"} marginLeft={"40%"}>
              {!state.isJupyterMI && (
                <Link to="/JupyterHub">
                  <Tooltip label={t('toolTip.tooltipNavbar.devToolsMenu.jupyterHub')} placement="right" >
                    <MenuItem isDisabled={state.isJupyterMI} _hover={{ bg: "gray.300" }}>
                      <Icon as={SiJupyter} mr={1} />Jupyter Hub
                    </MenuItem>
                  </Tooltip>
                </Link>
              )}
              {!state.isZeppelinMI && (
                <Link to="/Zeppelin">
                  <Tooltip label={t('toolTip.tooltipNavbar.devToolsMenu.zeppelin')} placement="right" >
                    <MenuItem isDisabled={state.isZeppelinMI} _hover={{ bg: "gray.300" }}>
                      <Icon as={GiZeppelin} mr={1} />Zeppelin
                    </MenuItem>
                  </Tooltip>
                </Link>
              )}
              {!state.isSupersetMI && (
                <>
                  <Link to="/Superset">
                    <Tooltip label={t('toolTip.tooltipNavbar.devToolsMenu.superset')} placement="right" >
                      <MenuItem isDisabled={state.isSupersetMI} _hover={{ bg: "gray.300" }}>
                        <Icon as={PiSupersetOf} mr={1} />Superset
                      </MenuItem>
                    </Tooltip>
                  </Link>
                  <MenuDivider />
                </>
              )}
              <Tooltip label={isUploadModalOpen ? null : t('toolTip.tooltipNavbar.devToolsMenu.uploadDataset')} placement="right" >
                <MenuItem isDisabled={state.isUploadMI} _hover={{ bg: "gray.300" }} onClick={() => { onUploadModalOpen(); setPayloadUploadRequest(defaultPayloadUploadRequestValue); setIsUploadUrl(false) }}>
                  <Icon as={MdAddBox} mr={1} />{t('navbar.uploadDataset')}
                </MenuItem>
              </Tooltip>
              {/* <Tooltip label={isUploadModalOpen ? null : t('toolTip.tooltipNavbar.devToolsMenu.uploadDataset')} placement="right" >
              <MenuItem isDisabled={state.isUploadMI} _hover={{ bg: "gray.300" }} onClick={() => { onUploadModalOpen(); setPayloadUploadRequest(defaultPayloadUploadRequestValue); setIsUploadUrl(true) }}>
                <Icon as={FaLink} mr={1} />{t('catalog.dataset.upload')} Dataset URL
              </MenuItem>
            </Tooltip> */}
              <Modal onClose={() => { onUploadModalClose(); setSelectedFileFormat(fileFormats[0].value); setPayloadUploadRequest(defaultPayloadUploadRequestValue) }} isOpen={isUploadModalOpen} isCentered closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader color="white" display="flex" justifyContent="space-between" bgColor={"#0888BE"}><Box>{isUploadUrl ? t('uploadDatasetModal.upload') + " Dataset URL" : t('uploadDatasetModal.upload') + " Dataset"}</Box> <Box><CloseButton disabled={isUploading} onClick={() => { onUploadModalClose(); setSelectedFileFormat(fileFormats[0].value); setPayloadUploadRequest(defaultPayloadUploadRequestValue); setIsUpdate(false) }} /></Box></ModalHeader>
                  <ModalBody>
                    <Stack spacing='4'>
                      <Box>

                        <FormControl mb={4} isRequired>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'> Dataset {t('uploadDatasetModal.version')}</FormLabel>
                          <NumberInput
                            min={1.0}
                            step={0.1}
                            precision={1}
                            defaultValue={1.0}
                            disabled={isUploading}
                            value={payloadUploadRequest.version} // Collega il valore allo stato 
                            onChange={(valueString) => handleChangePayloadRequest(valueString, 'version')}
                          >
                            <NumberInputField />
                            <NumberInputStepper>
                              <NumberIncrementStepper />
                              <NumberDecrementStepper />
                            </NumberInputStepper>
                          </NumberInput>
                        </FormControl>
                        <FormControl display='flex' alignItems='center'>
                          <FormLabel htmlFor='email-alerts' mb='2'>
                            {t('uploadDatasetModal.isTheFileAnUpdate')}
                          </FormLabel>
                          <Switch disabled={isUploading} id='email-alerts' onChange={(e) => handleChangePayloadRequest(e, "is_update")} />
                        </FormControl>
                        {isUpdate && (
                          <>
                            <Box bg="yellow.100" p={3} borderRadius="md">
                              <Text fontSize="sm" fontWeight="bold">
                                {t('uploadDatasetModal.msgFileUpdate')}
                              </Text>
                            </Box>
                            <FormControl mb={4} isRequired>
                              <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('uploadDatasetModal.updateDate')}</FormLabel>
                              <Input disabled={isUploading} type="date" required onChange={(e) => handleChangePayloadRequest(e, 'updateDate')} />
                            </FormControl>
                          </>
                        )}
                        {!isUpdate && (
                          <FormControl isRequired mb={4}>
                            <Box>
                              <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('uploadDatasetModal.title')} :</FormLabel>
                              <Input disabled={isUploading} placeholder='Titolo' onChange={(e) => handleChangePayloadRequest(e, "titolo")} />
                            </Box>
                          </FormControl>
                        )}
                        <FormControl isRequired>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('uploadDatasetModal.fileFormat')}:</FormLabel>
                          <Select disabled={Boolean(payloadUploadRequest.urlDownloadFile) || isUploading} onChange={(e) => handleChangePayloadRequest(e, "fileFormat")} >


                            {fileFormatsOptions.map(option => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}

                          </Select>
                        </FormControl>


                      </Box>

                      {/* <FormControl display='flex' alignItems='center'>
                          <FormLabel htmlFor='email-alerts' mb='0'>
                            {t('catalog.dataset.isTheFileAnUpdate')}
                          </FormLabel>
                          <Switch id='email-alerts' onChange={(e) => handleChangePayloadRequest(e, "is_update")} />
                        </FormControl> */}

                      {isUploadUrl && (
                        <Box>
                          <FormControl isRequired>
                            <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' >{t('uploadDatasetModal.insertLinkDownloadDataset')}:</FormLabel>
                            <InputGroup>
                              <Input
                                placeholder={t('uploadDatasetModal.insertUrl')}
                                value={currentUrl}
                                onChange={(e) => setCurrentUrl(e.target.value)}
                                disabled={Boolean(payloadUploadRequest.urlDownloadFile)}
                              />
                              <InputRightElement width="4.5rem">
                                <Button
                                  h="1.75rem"
                                  size="sm"
                                  colorScheme="teal"
                                  isLoading={isValidating}
                                  onClick={validateUrl}
                                  disabled={Boolean(payloadUploadRequest.urlDownloadFile)}
                                >
                                  {t('uploadDatasetModal.add')}
                                </Button>
                              </InputRightElement>
                            </InputGroup>
                          </FormControl>
                          {payloadUploadRequest.urlDownloadFile && (
                            <Box mt={2} mb={4} maxW="100%">
                              <HStack justify="space-between" w="100%">
                                <HStack flex="1" minW="0">
                                  <Icon as={MdCheckCircle} color="green" boxSize="15px" />
                                  <Tooltip label={payloadUploadRequest.urlDownloadFile} placement="right" >
                                    <Text fontSize="sm" isTruncated>
                                      {payloadUploadRequest.urlDownloadFile}
                                    </Text>
                                  </Tooltip>
                                </HStack>
                                <HStack>
                                  <Button
                                    size="xs"
                                    variant="ghost"
                                    colorScheme="blue"
                                    leftIcon={<FaDownload />}
                                    onClick={() => window.open(payloadUploadRequest.urlDownloadFile, '_blank')}
                                  >
                                    {t('uploadDatasetModal.download')}
                                  </Button>
                                  <Button
                                    size="xs"
                                    variant="ghost"
                                    colorScheme="red"
                                    leftIcon={<MdDelete />}
                                    onClick={removeUrl}
                                  >
                                    {t('uploadDatasetModal.remove')}
                                  </Button>
                                </HStack>
                              </HStack>
                            </Box>
                          )}
                        </Box>

                      )}
                      {!isUploadUrl && (
                        <Box>
                          <FormControl isRequired>
                            <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' >{t('uploadDatasetModal.selectFile')}:</FormLabel>
                            <Input disabled={isUploading || (payloadUploadRequest.fileFormat == null || payloadUploadRequest.fileFormat === "")} ref={fileSelectorRef} placeholder='Select file' name='file' type='file' bg='white' accept={selectedFileFormat} onChange={(e) => handleChangePayloadRequest(e, "file")} />
                          </FormControl>
                        </Box>
                      )}
                    </Stack>
                    {isUploading && (
                      <Box position="relative" width="100%" maxW="500px" height="24px" borderRadius="md" overflow="hidden">
                        <Progress value={uploadProgress} size="sm" colorScheme="green" height="100%" borderRadius="inherit" />
                        <Text
                          position="absolute"
                          left={uploadProgress >= 100 ? 'calc(100% - 40px)' : `calc(${uploadProgress}% - 30px)`}
                          top="50%"
                          transform="translateY(-50%)"
                          fontSize="sm"
                          fontWeight="bold"
                          color="white"
                        >
                          {Math.round(uploadProgress)}%
                        </Text>
                      </Box>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button colorScheme='green' mr={3} onClick={uploadDataset} isLoading={isUploading}>
                      {t('uploadDatasetModal.submit')}

                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Link to={"/status-informations"}>
                <Tooltip label={t('toolTip.tooltipNavbar.devToolsMenu.statusInformations')} placement="right" >
                  <MenuItem isDisabled={state.isDashboardMI} _hover={{ bg: "gray.300" }}>
                    <Icon as={BsFillInfoCircleFill} boxSize={5} mr={1} />{t('navbar.statusInformations')}
                  </MenuItem>
                </Tooltip>
              </Link>
            </MenuList>
          </Menu>
        </MenuItem>
      )}
      {/* SURVEY TOOLS */}
      {!state.isSurveyMB && (
        <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
          <Menu>
            <Tooltip label={state.isSurveyMB ? null : t('toolTip.tooltipNavbar.surveys.surveyTitle')} placement="right">
              <MenuButton disabled={state.isSurveyMB} color={!state.isSurveyMB ? "yellowgreen" : "gray.400"} cursor={!state.isSurveyMB ? "pointer" : "not-allowed"} w="100%" h="100%" paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
                transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }}
                _focus={{ boxShadow: 'outline' }}>
                <Icon as={RiSurveyLine} w={"30%"} h={"30%"} />
                <Text fontSize={"sm"}> {t('survey.name')} </Text>
              </MenuButton>
            </Tooltip>
            <MenuList border="solid" borderColor={"rgba(11,78,90,255)"} borderWidth={"1"} marginLeft={"40%"} >
              <Link to={"/surveys"}>
                <Tooltip label={t('toolTip.tooltipNavbar.surveys.surveyMenu.surveyCatalog')} placement="right" >
                  <MenuItem _hover={{ bg: "gray.300" }}>
                    <Icon as={RiSurveyLine} mr={"1%"} />{t('survey.surveyCatalog')}
                  </MenuItem>
                </Tooltip>

              </Link>
              <Link to={"/groups"}>
                <Tooltip label={t('toolTip.tooltipNavbar.surveys.surveyMenu.groupExpertCatalog')} placement="right" >
                  <MenuItem _hover={{ bg: "gray.300" }}>
                    <Icon as={MdGroups} mr={"1%"} />{t('survey.groupCatalog')}
                  </MenuItem>
                </Tooltip>
              </Link>
              <MenuDivider />
              <Link to={"/experts"}>
                <Tooltip label={t('toolTip.tooltipNavbar.surveys.surveyMenu.expertCatalog')} placement="right" >
                  <MenuItem _hover={{ bg: "gray.300" }}>
                    <Icon as={GrUserExpert} mr={"1%"} />{t('survey.expertCatalog')}
                  </MenuItem>
                </Tooltip>
              </Link>
              <MenuDivider />
              <Link to={"/surveys-consensus"}>
                <Tooltip label={t('toolTip.tooltipNavbar.surveys.surveyMenu.consensusSurveys')} placement="right" >
                  <MenuItem _hover={{ bg: "gray.300" }}>
                    <Icon as={FaFileContract} mr={"1%"} />{t('survey.surveyCatalogConsensus')}
                  </MenuItem>
                </Tooltip>
              </Link>
            </MenuList>
          </Menu>
        </MenuItem>
      )}

      {/* GEOPORTAL */}
      {/* {!state.isGeoportalMB && (
        <MenuItem _focus={{ bg: "#006778" }} paddingRight={0} paddingLeft={0} paddingTop={0} mb={2} paddingBottom={0}>
          <Tooltip label={state.isGeoportalMB ? t('toolTip.tooltipNavbar.geoportal') : null} placement="right">
            <MenuButton
              onClick={() => {
                if (state.isGeoportalMB) {
                  console.log('Geoportal clicked');
                }
              }}
              disabled={!state.isGeoportalMB}
              color={state.isGeoportalMB ? "yellowgreen" : "gray.400"}
              cursor={state.isGeoportalMB ? "pointer" : "not-allowed"}
              w="100%"
              h="100%"
              paddingRight="2%"
              paddingLeft="2%"
              paddingTop="2%"
              paddingBottom="2%"
              transition="all 0.2s"
              borderRadius="md"
              _hover={state.isGeoportalMB ? { boxShadow: "dark-lg" } : {}}
              _expanded={{ bg: 'blue.400' }}
              _focus={{ boxShadow: 'outline' }}
              display="flex"
              alignItems="center"
            >
              <Icon as={TbWorld} w="30%" h="30%" />
              <Text fontSize="sm" ml={1}>Geoportal</Text>
            </MenuButton>
          </Tooltip>
        </MenuItem>
      )} */}
      {/* FINE Geoportal */}

      <Box mt="auto" alignSelf={"bottom"} h="15%">
        <MenuItem _focus={{ bg: "#006778" }} padding={0}>
          <Menu>
            <Tooltip label={state.isProfileButtonMB ? null : t('toolTip.tooltipNavbar.profile')} placement="right">
              <MenuButton disabled={state.isProfileButtonMB} color={!state.isProfileButtonMB ? "yellowgreen" : "gray.400"} cursor={!state.isProfileButtonMB ? "pointer" : "not-allowed"} w="100%" h="100%" paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
                transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }} _expanded={{ bg: 'blue.400' }} >
                {sessionStorage.displayName === "anonymous" || !sessionStorage.displayName ? (<Icon as={MdOutlinePerson} w={"30%"} h={"30%"} />) : (generateAvatar(sessionStorage.displayName))}
                <Text fontSize={"sm"}> {t('navbar.profile')} </Text>
              </MenuButton>
            </Tooltip>
            <MenuList border="solid" borderColor={"rgba(11,78,90,255)"} borderWidth={"1"} marginLeft={"40%"}>
              {!state.isChangePasswordMI &&(
                <>
                  <Tooltip
                    label={t('toolTip.tooltipNavbar.profileMenu.changePassword')}
                    placement="right"
                  >
                    <MenuItem isDisabled={state.isChangePasswordMI} _hover={{ bg: "gray.300" }} onClick={onChangePasswordModalOpen}>
                      <Icon as={MdLockReset} mr={1} /> {t('navbar.changePassword')}
                    </MenuItem>
                  </Tooltip>
                  <MenuDivider />
                </>
              )}

              <Modal onClose={onChangePasswordModalClose} isOpen={isChangePasswordModalOpen} isCentered closeOnOverlayClick={false}>
                <Icon as={MdLockReset} mr={1} /> {t('navbar.changePassword')}

                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bgColor={"#0888BE"} color="white" display="flex" justifyContent="space-between"><Box>{t('navbar.changePassword')}</Box> <Box><CloseButton onClick={onChangePasswordModalClose} /></Box></ModalHeader>
                  <ModalBody>
                    <Stack spacing='4'>
                      <Text>
                        {/* The password must be at least <b>8 characters long </b> and must contain <n />
                          at least <b>one special character</b>,
                          at least <b>one number</b>, and
                          at least<b> one uppercase letter</b>. */}

                        <span dangerouslySetInnerHTML={{ __html: t('navbar.changePasswordMsg') }} />
                      </Text>

                      <Box>
                        <FormControl isRequired>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold'>{t('navbar.newPassword')}</FormLabel>
                          <InputGroup>
                            <Input borderColor={"blue.300"} variant='filled' placeholder={t('navbar.newPassword')} name='NuovaPassword1' type={showPassword1 ? "text" : "password"} bg='white' onChange={(e) => handleChangePassword1(e)} />
                            <InputRightElement width="3rem">
                              <Button h="1.75rem" size="sm" onClick={handlePasswordVisibility1} bg="transparent">
                                {showPassword1 ? <Icon as={MdVisibilityOff} boxSize={5} /> : <Icon as={MdVisibility} boxSize={5} />}
                              </Button>
                            </InputRightElement>
                          </InputGroup>
                        </FormControl>
                      </Box>
                      <Box>
                        <FormControl isRequired>
                          <FormLabel fontSize='lg' color="rgba(11,78,90,255)" fontWeight='semibold' >{t('navbar.enterAgainNewPassword')}:</FormLabel>
                          <InputGroup>
                            <Input borderColor={"blue.300"} variant='filled' placeholder={t('navbar.enterAgainNewPassword')} name='NuovaPassword2' type={showPassword2 ? "text" : "password"} bg='white' onChange={(e) => handleChangePassword2(e)} />
                            <InputRightElement width="3rem">
                              <Button h="1.75rem" size="sm" onClick={handlePasswordVisibility2} bg="transparent">
                                {showPassword2 ? <Icon as={MdVisibilityOff} boxSize={5} /> : <Icon as={MdVisibility} boxSize={5} />}
                              </Button>
                            </InputRightElement>
                          </InputGroup>
                        </FormControl>
                      </Box></Stack>
                  </ModalBody>
                  <ModalFooter>
                    <Button colorScheme='green' mr={3} onClick={() => changePasswordADP()}>
                      {t('navbar.continue')}
                    </Button>

                  </ModalFooter>
                </ModalContent>
              </Modal>

              <Modal onClose={onChangeLogoutPasswordModalClose} isOpen={isLogoutChangePasswordModalOpen} isCentered closeOnOverlayClick={false} >
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader bgColor={"#0888BE"} color="white" display="flex" justifyContent="space-between"><Box>Logout</Box></ModalHeader>
                  <ModalBody>
                    <Stack spacing='4'>
                      <Text>
                        {responseChangePassword.message ? t(`messageBE.${responseChangePassword.message}`) : ''}
                      </Text>

                    </Stack>
                  </ModalBody>
                  <ModalFooter>
                    <Button colorScheme='green' mr={3} onClick={() => logOut()}>
                      Logout
                    </Button>

                  </ModalFooter>
                </ModalContent>
              </Modal>
              {!state.isInfoMI &&(
                <>
                  <Link to="/info">
                    <Tooltip label={t('toolTip.tooltipNavbar.profileMenu.info')} placement="right" >
                      <MenuItem isDisabled={state.isInfoMI} _hover={{ bg: "gray.300" }} >
                        <Icon as={BsFillInfoCircleFill} boxSize={5} mr={1} /> Info
                      </MenuItem>
                    </Tooltip>
                  </Link>
                  <MenuDivider />
                </>
              )}

              {/* {state.isDigitalAssistantMI && (
                <>
                  <Tooltip label="Digital Assistant" placement="right">
                    <MenuItem
                      isDisabled={false}
                      _hover={{ bg: 'gray.300' }}
                      onClick={openAssistant}
                    >
                      <Icon as={FaRobot} boxSize={5} mr={1} /> Amelia Assistant
                    </MenuItem>
                  </Tooltip>
                  <MenuDivider />
                </>
              )} */}

              <Tooltip label={t('toolTip.tooltipNavbar.profileMenu.logout')} placement="right" >
                <MenuItem bgColor={"gray.100"} onClick={onLogoutModalOpen} _hover={{ bg: "gray.300" }} >
                  <Icon as={ImExit} boxSize={5} mr={1} /> Logout
                </MenuItem>
              </Tooltip>

              <Modal onClose={onLogoutModalClose} isOpen={isLogoutModalOpen} isCentered closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent>
                  <ModalHeader> {t('navbar.doYouConfirmYouWantToLeaveTheSession')}</ModalHeader>
                  <ModalBody></ModalBody>
                  <ModalFooter>
                    <Button colorScheme='green' mr={3} onClick={logOut}>
                      {t('navbar.yes')}
                    </Button>
                    <Button colorScheme='red' onClick={onLogoutModalClose}>
                      No
                    </Button>
                  </ModalFooter>
                </ModalContent>
              </Modal>
            </MenuList>

          </Menu>

        </MenuItem>

        {/* <MenuItem padding={0} bgColor="#BE3C08" w="100%" h="50%">
          <MenuButton color={"white"} w="100%" h="100%" paddingRight={"2%"} paddingLeft={"2%"} paddingTop={"2%"} paddingBottom={"2%"}
            transition='all 0.2s' borderRadius='md' _hover={{ boxShadow: "dark-lg" }}
            onClick={onLogoutModalOpen}><Icon as={IoMdPower} w={"30%"} h={"30%"} />

          </MenuButton>
          <Modal onClose={onLogoutModalClose} isOpen={isLogoutModalOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader> Do you confirm you want to leave the session?</ModalHeader>
              <ModalBody></ModalBody>
              <ModalFooter>
                <Button colorScheme='green' mr={3} onClick={logOut}>
                  Si
                </Button>
                <Button colorScheme='red' onClick={onLogoutModalClose}>
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

        </MenuItem> */}
      </Box>

    </Menu>

  )

}

export default Navbar;



